import React from 'react';
import { useTranslation } from 'next-i18next';
import NextLink from 'next/link';
import { Avatar } from '@dentalux/ui-library-core/components/avatar';
import { Box, Link } from '@mui/material';
import PractitionerDetails from 'src/components/PractitionerDetails';
import getPractitionerRoles from 'src/helpers/getPractitionerRoles';
import * as S from '../../AppointmentView.styles';
import DentalTreatment from '../DentalTreatments';
const DesktopView = ({
  practitioner,
  treatments,
  treatmentTitle,
  LocationLink,
  clinic,
  labels,
  date,
  time
}) => {
  const {
    t,
    i18n: {
      language
    }
  } = useTranslation();
  const hasDentalTreatments = treatments.length > 0 || treatmentTitle;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.SectionItem, {
    label: labels.date,
    value: /*#__PURE__*/React.createElement(S.DateTime, null, date, " ", time)
  }), practitioner && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.Divider, null), /*#__PURE__*/React.createElement(S.SectionItem, {
    label: /*#__PURE__*/React.createElement(PractitionerDetails, {
      avatar: /*#__PURE__*/React.createElement(Avatar, {
        src: practitioner?.imageUrl
      }),
      title: practitioner.name,
      subTitle: getPractitionerRoles(practitioner, t, language)
    }),
    value: /*#__PURE__*/React.createElement(NextLink, {
      href: `/practitioner/${practitioner.referenceId}`,
      passHref: true
    }, /*#__PURE__*/React.createElement(Link, {
      target: "_blank"
    }, labels.viewProfile))
  })), hasDentalTreatments && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.Divider, null), /*#__PURE__*/React.createElement(S.SectionItem, {
    label: labels.treatment,
    value: /*#__PURE__*/React.createElement(React.Fragment, null, treatmentTitle && /*#__PURE__*/React.createElement(S.Text, null, treatmentTitle), treatments.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, treatmentTitle && /*#__PURE__*/React.createElement(S.Text, {
      sx: {
        pb: 0.5,
        pt: 1.5
      }
    }, labels.details), /*#__PURE__*/React.createElement(DentalTreatment, {
      data: treatments
    })))
  })), /*#__PURE__*/React.createElement(S.Divider, null), /*#__PURE__*/React.createElement(S.SectionItem, {
    label: labels.clinic,
    value: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.Text, null, clinic?.officialName), !!LocationLink && /*#__PURE__*/React.createElement(Box, {
      sx: {
        pt: 1.5
      }
    }, LocationLink), clinic?.phoneNumber && /*#__PURE__*/React.createElement(S.Text, {
      sx: {
        pt: 1
      }
    }, clinic.phoneNumber))
  }));
};
export default DesktopView;